module.exports = __webpack_public_path__ + "static/media/smugglersbay.af02232e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rimages/smugglersbay.jpg
// module id = 100
// module chunks = 0